/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react-hooks/exhaustive-deps */
// @ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Table } from "../../Table/Table";
import {
  arrow_icon,
  delete_icon,
  dummyimage,
  edit_icon,
  view_icon,
} from "../../../assets/img";
import { toast } from "react-toastify";
import { deletes, get, patch } from "../../../Services/ApiHandler";
import { URLS } from "../../../Services/Constant";
import { checkPermission } from "../../../screen/redux/api/PermissionManager";

const RoomLiveBooking = ({ service_id }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const property_id = location.state?.id;
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [popup, setPopup] = useState(false);
  const [policy, setPolicy] = useState("");
  const [names, setNames] = useState([]);
  const [roomData, setRoomData] = useState([]);
  const createdCategories = useRef([]);
  console.log("service_id", service_id, property_id);
  useEffect(() => {
    getList();
  }, []);

  const getList = async () => {
    console.log("service Is", service_id);
    const res = await get(`${URLS.ROOMS_LIST}${property_id}/${service_id}/`);
    console.log("rooms list", res);
    if (res?.status === "success") {
      const data = res?.data ?? [];
      const roomDetails = res?.room_details ?? [];

      const valid = roomDetails.every((i) => i?.room_category_name);

      const typeArr = data.map((i) => String(i?.room_category_id));

      const newArr = data.map((i) => {
        const matchedRoom = roomDetails.find(
          (it) => String(it?.room_type) === String(i?.room_category_id),
        );

        return {
          ...i,
          time_slots: matchedRoom?.time_slots ?? [],
        };
      });

      const filteredArr = roomDetails.filter(
        (i) => !typeArr.includes(String(i?.room_type)),
      );

      const arr = valid ? [...newArr, ...filteredArr] : newArr;

      setList(arr);

      console.log("Final room list:", arr);

      setNames(res?.hints || []);
      let categories = res?.data?.map((item) => ({
        value: item?.room_category_id,
      }));

      let room_categories = res?.room_details?.map((item) => ({
        value: item?.room_type,
      }));

      createdCategories.current = [...categories, ...room_categories];
    }
  };
  console.log("deleted room list", createdCategories);

  const addHint = (e) => {
    e.preventDefault();
    console.log("event", policy, names);
    if (!policy) {
      toast.error("Hints Cannot be Empty");
    }
    // if (policy.trim() !== "") {
    const formattedPolicy = policy.trim().toLowerCase();

    const formattedNames = names.map((item) => item.trim().toLowerCase());

    if (formattedNames.includes(formattedPolicy)) {
      toast.warn("All Ready added");
    }
    // }
    if (policy.trim() !== "") {
      setNames((prev) => [...prev.filter((i) => i !== policy), policy]);
      setPolicy("");
    }
  };
  const handleDelete = async (id) => {
    const res = await deletes(`${URLS.MASTER_ROOM_BOOKING}${id}/delete/`);
    console.log("room booking status", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      setPopup(false);
      getList();
    }
  };
  const handleDeleteHint = async (hint) => {
    setNames((prev) => prev.filter((item) => item !== hint));
  };

  const handleStatus = async (id, val) => {
    let payload = {
      status: val === 2 ? 1 : 2,
    };
    const res = await patch(
      `${URLS.MASTER_ROOM_BOOKING}${id}/status/`,
      payload,
    );
    console.log("room booking status", res);
    if (res?.status === "success") {
      getList();
      toast.success(res?.message);
    }
  };

  const hintAdd = async () => {
    const res = await patch(
      `${URLS.ADD_HINTS}${property_id}/${service_id}/update/`,
      {
        hints: names,
      },
    );
    console.log("add hints", res);
    if (res?.status === "success") {
      toast.success(res?.message);
    }
  };

  // const getBlock = async (id, val) => {
  //   console.log("URLFOR BLOCK", `${URLS.AVAILABLE_ROOM}/${property_id}/${id}`);
  //   const res = await get(`${URLS.AVAILABLE_ROOM}/${property_id}/${id}`);
  //   console.log("rooms list", res !== {});
  //   if (res !== {}) {
  //     // setList(res?.data || []);
  //     // setNames(res?.hints || []);
  //   }
  // };
  const handleNavigate = (type, room_id, data) => {
    // console.log("navigation deleted", createdCategories);
    console.log("data--->", data);
    let use_time_slot = !data?.id || !data?.property_room_exist;
    // return;
    navigate("/room-booking-view", {
      state: {
        type: type,
        property_id: property_id,
        room_id: room_id,
        service_id: service_id,
        selectedCategories: createdCategories.current,
        data: data,
        use_time_slot: use_time_slot,
      },
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Image",
        accessor: "default_image",
        Cell: ({ value, row }) => {
          return (
            <img
              alt=""
              src={value ?? row?.original?.room_default_image ?? dummyimage}
              className="list-img"
            />
          );
        },
      },
      {
        Header: "Categories",
        accessor: "room_category_name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Total Room",
        accessor: "total_rooms",
        Cell: ({ value, row }) => {
          return <p>{value ?? row?.original?.rooms_count}</p>;
        },
      },

      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          let ID = !row?.original?.id;
          return (
            <div>
              {ID ? (
                <button
                  className={`${"active-btn"} border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                  style={{ opacity: 0.4 }}
                >
                  Active
                </button>
              ) : (
                <button
                  onClick={() => {
                    handleStatus(row.original.id, value);
                  }}
                  className={`${
                    value === 1 ? "active-btn" : "deactive-btn"
                  } border-0  fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13`}
                >
                  {value === 1 ? " Active" : "De-active"}
                </button>
              )}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "id",
        Cell: ({ value, row }) => {
          let ID = !row?.original?.id;
          return (
            <React.Fragment>
              <div className="d-flex ac-js gap-3">
                {checkPermission("CAN-VIEW-OVERALL_PROPERTIES") && (
                  <button
                    onClick={() => {
                      handleNavigate("view", value, row?.original);
                      // AdminView(row.original.id, "view");
                    }}
                    className="cust-btn "
                    disabled={ID}
                    style={{
                      opacity: ID ? 0.4 : 1,
                    }}
                  >
                    <img src={view_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-EDIT-OVERALL_PROPERTIES") && (
                  <button
                    onClick={() => {
                      handleNavigate("edit", value, row?.original);
                      // AdminView(row.original.id, "edit");
                    }}
                    className="cust-btn "
                  >
                    <img src={edit_icon} alt="" className=" edit-btn " />
                  </button>
                )}
                {checkPermission("CAN-DELETE-OVERALL_PROPERTIES") && (
                  <button
                    onClick={() => setPopup(value)}
                    // onClick={() => setDeletePopup(row.original.id)}
                    className="cust-btn "
                    disabled={ID}
                    style={{ opacity: ID ? 0.4 : 1 }}
                  >
                    <img src={delete_icon} alt="" className=" edit-btn " />
                  </button>
                )}
              </div>
            </React.Fragment>
          );
        },
      },
    ],
    [page],
  );

  return (
    <div>
      <div className="d-flex ac-je mt-4">
        {/* {rolePermissions?.includes('CAN-ADD-ADMIN') && */}
        <button
          onClick={() => handleNavigate("add")}
          className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 white add-btn "
        >
          {" "}
          + Add New
        </button>
        {/* } */}
      </div>
      <Table columns={columns} setPageno={setPage} data={list} show={false} />
      <div className="mt-4 col-md-8">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
          Hints
        </p>
        <div className="d-flex flex-column ae-js">
          <div className="d-flex ae-jb input-border p-1">
            <textarea
              style={{ maxHeight: "80px" }}
              // maxLength={250}
              value={policy}
              onChange={(e) => setPolicy(e.target.value)}
              placeholder="Hints"
              // onKeyPress={handleKeyPress}
              className="border-0 mb-3 w-100"
            />
          </div>
          <div className="d-flex gap-3">
            {checkPermission("CAN-ADD-OVERALL_PROPERTIES") && (
              <div>
                <button
                  onClick={addHint}
                  className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                  style={{ minWidth: "150px" }}
                  // className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 p-1 mt-4 me-4"
                  // style={{ minWidth: "150px" }}
                >
                  Add
                </button>
              </div>
            )}
            <div>
              <button
                onClick={hintAdd}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "
                style={{ minWidth: "150px" }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
        <div>
          {names.length > 0 && (
            <ul
              className=" overflow-scroll mt-2"
              style={{ minHeight: "50px", maxHeight: "200px" }}
            >
              {names?.map((name, index) => {
                return (
                  <li className="d-flex as-jb mt-2" key={index}>
                    <img src={arrow_icon} className="bullet-btn" alt="" />
                    <p className="f2 fs-sm-10 fs-md-14 fs-lg-15 fs-xl-14 fs-xxl-16 w-80 text-start">
                      {name}
                    </p>
                    {/* {type == "edit" && ( */}
                    <img
                      src={delete_icon}
                      className="edit-btn"
                      onClick={() => {
                        handleDeleteHint(name);
                      }}
                    />
                    {/* )} */}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>

      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => {
                  handleDelete(popup);
                }}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RoomLiveBooking;
